import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  saveNewPackageSet: {
    description: 'multiPackageModal.saveNewPackageSet',
    defaultMessage: 'Save New Multi-Package Set',
    id: 'PCJqJx',
  },
  multiPackageTitle: {
    defaultMessage: 'Multi-Package Shipment',
    description: 'multiPackageModal.title',
    id: 'LBJNgG',
  },
  addPackage: {
    defaultMessage: 'Add Package',
    description: 'multiPackageModal.addPackage',
    id: 'uAE47H',
  },
  sidePanelPackagesLabel: {
    defaultMessage: 'Packages',
    description: 'multiPackageModal.packages',
    id: 'm0Zxy8',
  },
  addPackagesLabel: {
    defaultMessage: 'Add {numberOfPackages} Packages',
    description: 'multiPackageModal.packageOption',
    id: 'DcQvP1',
  },
  savePackagesButton: {
    defaultMessage: 'Save Packages',
    description: 'multiPackageModal.savePackages',
    id: 'xn9eZG',
  },
  sidePanelTotalWeightLabel: {
    defaultMessage: 'Total Weight',
    description: 'Total weight label for Multi package modal side panel',
    id: 'zi2pxA',
  },
  sidePanelTotalInsuranceLabel: {
    defaultMessage: 'Total Insurance',
    description: 'Total insurance label for Multi package modal side panel',
    id: 'RX8hxA',
  },
  multiPackageNotSupported: {
    description: 'banner message for multi-package not supported',
    defaultMessage: 'Selected carrier does not support multi-package shipping. You will need to select a new service.',
    id: '1Hjfjb',
  },
  packageSetNameLabel: {
    description: 'Label for package set name input',
    defaultMessage: 'Name',
    id: 'SMSKKo',
  },
  saveNewPackageSetButton: {
    description: 'Button to save new package set',
    defaultMessage: 'Save Set',
    id: '01Q7pO',
  },
  multiPackageSettingsTitle: {
    description: 'Title for multi-package settings modal',
    defaultMessage: 'Create multi-package set',
    id: 'KHTn4I',
  },
  multiPackageApplySetButton: {
    description: 'Button to apply multi-package set',
    defaultMessage: 'Apply Multi-Package Set',
    id: 'QcL4K2',
  },
});
